<script>
    import { Tooltip } from 'sveltestrap';

    // Content properties - A title or an icon can be provided.
    export let title = undefined;
    export let icon = undefined;

    // Display properties - Styling and layout properties for the table header cell.  
    export let width = undefined; // Optional width for the table header cell, can be used to set a fixed width for the column
    export let center = false; // If true, the data will be displayed centered in the table header cell. If an icon is provided, this will be set to true automatically.
    export let action = false; // If true, the table header cell is for an action column, which may have different styling.
    export let classes = undefined; // Additional classes to apply to the table header cell

    // Tooltip properties - An optional tooltip can be added to the table header cell.
    export let tooltipId = undefined;
    export let tooltipText = undefined;

    // Sorting properties - Display data as sorted (Ascending) or reverse sorted (Descending). Set invertSortOrder to flip this logic.
    export let propertyName;
    export let sortProperty;
    export let reverseSorted = false;
    export let invertArrow = false;
</script>

<style>
    :global(th span.sort-icon) {
        font-size: 11px;
    }

    :global(th.th-xs) {
        width: 26px;
    }

    /* The XS (icon) header is slightly larger for action columns */
    :global(th.th-xs.th-action) {
        width: 28px;
    }

    /* The XS (icon) header must be made larger to accommodate the sort icon */
    :global(th.th-xs.th-sorted) {
        width: 36px;
    }

    :global(th.th-sm) {
        width: 68px;
    }

    :global(th.th-md) {
        width: 82px;
    }

    :global(th.th-lg) {
        width: 120px;
    }

    :global(th.th-xl) {
        width: 240px;
    }

    :global(th.th-xxl) {
        width: 300px;
    }
</style>

<th on:click class="{classes}"
             class:table-text-center={center || icon}
             class:th-xs={width && width === 'xs' || icon}
             class:th-sm={width && width === 'sm'}
             class:th-md={width && width === 'md'}
             class:th-lg={width && width === 'lg'}
             class:th-xl={width && width === 'xl'}
             class:th-xxl={width && width === 'xxl'}
             class:th-action={action}
             class:th-sorted={propertyName === sortProperty}>
    <!-- If a title or icon is provided display this, otherwise display the slotted data -->
    {#if title || icon}
        <span id={tooltipId}>
            {#if title}
                {title}
            {:else if icon}
                <i class="bi bi-{icon}" />
            {/if}
        </span>
    {:else}
        <slot />
    {/if}
    {#if tooltipId && tooltipText}
        <Tooltip target="{tooltipId}" placement="bottom">{tooltipText}</Tooltip>
    {/if}
    <!-- If the data property for this column matches the current sort property then the column should be sorted -->
    {#if propertyName === sortProperty }
        {#if (reverseSorted && !invertArrow) || (!reverseSorted && invertArrow)}
            <span class="sort-icon"><i class="bi bi-chevron-double-down" /></span>
        {:else}
            <span class="sort-icon"><i class="bi bi-chevron-double-up" /></span>
        {/if}
    {/if}
</th>